import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import api from "../../../helpers/api";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

// Identity helper for multi-region lookup
import { lookupByEmail, regionalLogin } from "../../../helpers/identity_helper";

function* loginUser({ payload: { user, history } }) {
  try {
    // Step 1: Look up user's region via identity service
    const regionInfo = yield call(lookupByEmail, user.email);

    if (!regionInfo) {
      yield put(apiError("Account not found. Please check your email."));
      return;
    }

    // Step 2: Store regional info
    localStorage.setItem("regionalApiUrl", regionInfo.apiBaseUrl);
    localStorage.setItem("region", regionInfo.region);

    // Update axios default base URL for subsequent requests
    axios.defaults.baseURL = regionInfo.apiBaseUrl;

    // Step 3: Login against the regional backend (cookies set automatically via Set-Cookie)
    const response = yield call(regionalLogin, regionInfo.apiBaseUrl, {
      identifier: user.email,
      password: user.password,
    });

    // Store user profile data WITHOUT the token (token is in HttpOnly cookie)
    const { token, ...userData } = response;
    localStorage.setItem("authUser", JSON.stringify(userData));
    yield put(loginSuccess(userData));

    history("/reactive");
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Login failed. Please try again.";
    yield put(apiError(message));
  }
}

function* logoutUser() {
  try {
    // Call backend to clear cookies and revoke refresh token
    yield call([api, api.post], 'user/logout');
  } catch (error) {
    // Ignore errors — proceed with local cleanup
  }
  localStorage.removeItem("authUser");
  localStorage.removeItem("regionalApiUrl");
  localStorage.removeItem("region");
  localStorage.removeItem("token");
  yield put(logoutUserSuccess(LOGOUT_USER, true));
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
